// extracted by mini-css-extract-plugin
export default {"imgHover":"CreatePost_imgHover__0KBuF"};